<template>
  <div>
    <topbar/>
    <div style="padding-left:5%; padding-right:5%; padding-bottom:2%;">
      <form>
        <h1 class="mt-5">Create new project</h1>
        <div class="col-12 text-secondary">
          <label for="projectNameInput">Project name</label>
        </div>
        <div class="form-group">
          <div class="input-group mb-2">
            <input v-model="name" type="text" class="form-control" id="projectNameInput"
                   placeholder="Project name">
          </div>
        </div>

        <div class="col-12 text-secondary">
          <label for="intentNameInput">Intent name</label>
        </div>
        <div class="form-group">
          <div class="input-group mb-2">
            <input v-model="intentName" type="text" class="form-control" id="intentNameInput"
                   placeholder="Intent name">
          </div>
        </div>

        <div class="col-12 text-secondary">
          <label for="shortSummaryInput">Short intent summary</label>
        </div>
        <div class="form-group">
          <div class="input-group mb-2">
            <input v-model="intentShort_summary" type="text" class="form-control" id="shortSummaryInput"
                   placeholder="">
          </div>
        </div>

        <div class="col-12 text-secondary">
          <label for="longSummaryInput">Long intent summary</label>
        </div>
        <div class="form-group">
          <div class="input-group mb-2">
                  <textarea v-model="intentLong_summary" class="form-control" rows = "6" cols = "60" name = "description"
                            placeholder="" id="longSummaryInput"></textarea>
          </div>
        </div>

        <h2 class="mt-5">Logical framework matrix</h2>

        <table class="table table-bordered table-active">
          <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Project summary</th>
            <th scope="col">Indicators</th>
            <th scope="col">Means of verifications</th>
            <th scope="col">Assumptions</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th scope="row">Goals</th>
            <td><textarea v-model="matrixGoals[0]" id="textarea11" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixIndicators[0]" id="textarea12" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixSources[0]" id="textarea13" class="form-control" rows="3" cols="10"></textarea></td>
            <td></td>

          </tr>
          <tr>
            <th scope="row">Output</th>
            <td><textarea v-model="matrixGoals[1]" id="textarea21" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixIndicators[1]" id="textarea22" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixSources[1]" id="textarea23" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixAssumption[1]" id="textarea24" class="form-control" rows="3" cols="10"></textarea></td>

          </tr>
          <tr>
            <th scope="row">Outcome</th>
            <td><textarea v-model="matrixGoals[2]" id="textarea31" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixIndicators[2]" id="textarea32" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixSources[2]" id="textarea33" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixAssumption[2]" id="textarea34" class="form-control" rows="3" cols="10"></textarea></td>

          </tr>
          <tr>
            <th scope="row">Activities</th>
            <td><textarea v-model="matrixGoals[3]" id="textarea41" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixIndicators[3]" id="textarea42" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixSources[3]" id="textarea43" class="form-control" rows="3" cols="10"></textarea></td>
            <td><textarea v-model="matrixAssumption[3]" id="textarea44" class="form-control" rows="3" cols="10"></textarea></td>

          </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6">
            <router-link to="/">
              <button type="button" class="btn btn-danger">Cancel</button>
            </router-link>
          </div>
          <div class="col-12 col-sm-6 col-md-6">
            <button type="button" class="btn btn-success float-right" @click="submit">Create project</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Topbar from '../components/Topbar'
export default {
  name: 'ProjectNew',
  components: { Topbar },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    submit () {
      this.$store.dispatch('addProject', {
        name: this.name,
        owner: {
          id: this.user.id
        },
        intent: {
          name: this.intentName,
          short_summary: this.intentShort_summary,
          long_summary: this.intentLong_summary
        },
        matrix: {
          goals: this.matrixGoals.join('|'),
          indicators: this.matrixIndicators.join('|'),
          sources: this.matrixSources.join('|'),
          assumption: this.matrixAssumption.join('|')
        }
      })
    }
  },
  data () {
    return {
      name: '',
      intentName: '',
      intentShort_summary: '',
      intentLong_summary: '',
      matrixGoals: [],
      matrixIndicators: [],
      matrixSources: [],
      matrixAssumption: []
    }
  }
}
</script>

<style scoped>

</style>
